import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { assertCondition } from '../../../utils/types';
import {
  AnalysisStatus,
  IAnalysisVisitFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';

const initialState: Array<IAnalysisVisitFieldsFragment> = [];

export default createSlice({
  name: 'analysesVisits',
  initialState,
  reducers: {
    populateAnalysesVisits: (
      _,
      action: PayloadAction<IAnalysisVisitFieldsFragment[]>,
    ) => {
      return action.payload;
    },
    resetAnalysesVisits: () => {
      return initialState;
    },
    updateAnalysisVisitStatus: (
      draft,
      action: PayloadAction<{
        id: string;
        status: AnalysisStatus;
      }>,
    ) => {
      const { id, status } = action.payload;

      const visitIndex = draft.findIndex((visit) => visit.id === id);

      if (visitIndex !== -1) {
        draft[visitIndex].status = status;
      }
    },

    renameAnalysisVisit: (
      draft,
      action: PayloadAction<{
        analysisId: string;
        analysisName: string;
      }>,
    ) => {
      const { analysisId, analysisName } = action.payload;

      const analysisIndex = draft.findIndex(
        (analysis) => analysis.id === analysisId,
      );

      assertCondition(analysisIndex !== -1);

      draft[analysisIndex].display = analysisName;
    },

    recordAnalysisVisit: (
      state,
      action: PayloadAction<{
        visit: IAnalysisVisitFieldsFragment;
      }>,
    ) => {
      const { visit } = action.payload;

      const visitIndex = state.findIndex(
        (stateVisit) => stateVisit.id === visit.id,
      );

      // If visit already in the list - just set it first
      if (visitIndex !== -1) {
        const items = state.splice(visitIndex, 1);
        state.splice(0, 0, ...items);
      } else {
        // If it's a new visit - unshift it
        state.unshift(visit);
      }
    },
  },
});
